/**
 * Auth State Reducer
 * Manages authentication state transitions
 */
export const initialAuthState = {
    isLoading: false,
    isAuthenticated: false,
    user: null,
    tokens: null,
    error: null,
    mfaState: null,
};
export function authReducer(state, action) {
    switch (action.type) {
        case "AUTH_LOADING":
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case "AUTH_SUCCESS":
            return {
                ...state,
                isLoading: false,
                isAuthenticated: true,
                user: action.payload.user,
                tokens: action.payload.tokens,
                error: null,
                mfaState: null,
            };
        case "AUTH_ERROR":
            return {
                ...state,
                isLoading: false,
                isAuthenticated: false,
                error: action.payload,
                // Preserve mfaState if it exists (allows retry after incorrect OTP)
                // Only clear mfaState if it's a non-MFA error
                mfaState: state.mfaState || null,
            };
        case "AUTH_LOGOUT":
            return {
                ...initialAuthState,
                isLoading: false,
            };
        case "AUTH_MFA_REQUIRED":
        case "AUTH_MFA_CHALLENGE":
            return {
                ...state,
                isLoading: false,
                mfaState: action.payload,
            };
        case "AUTH_MFA_SUCCESS":
        case "AUTH_CLEAR_MFA_STATE":
            return {
                ...state,
                mfaState: null,
            };
        case "AUTH_TOKEN_REFRESH":
            return {
                ...state,
                tokens: action.payload,
            };
        case "AUTH_CLEAR_ERROR":
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
}
//# sourceMappingURL=authReducer.js.map